import  kickstartApp  from "./index";

class MPR {
    
    constructor() {
        this._MPRStauts = "inactive";
        this._originalSeriesData = []; // 源序列数据
        this._axialSeriesData = []; // 轴向序列数据
        this._axialSeriesDom = null
        this._coronalSeriesData = []; // 冠状面序列数据
        this._coronalSeriesDom = null
        this._sagittalSeriesData = []; // 矢状面序列数据
        this._sagittalSeriesDom = null
        this._vtkVolumes = []
    }
  
  static getInstance() {
    if (!MPR.instance) {
      MPR.instance = new MPR();
      return MPR.instance;
    }
    return MPR.instance;
  }

  get MPRStauts() {
    return this._MPRStauts;
  }
  set MPRStauts(type) {
    this._MPRStauts = type;
  }
  set OriginalSeriesData(list = []) {
    this._originalSeriesData = list;
  }
  get OriginalSeriesData() {
    return  this._originalSeriesData;
  }

  set axialSeriesDom(dom){
    this._axialSeriesDom = dom
  }
  get axialSeriesDom(){
    return this._axialSeriesDom
  }
  set coronalSeriesDom(dom){
    this._coronalSeriesDom = dom
  }
  get coronalSeriesDom(){
    return this._coronalSeriesDom
  }
  set sagittalSeriesDom(dom){
    this._sagittalSeriesDom = dom
  }
  get sagittalSeriesDom(){
    return this._sagittalSeriesDom
  }
  // 设置 Axial 的url
  setAxialMprUrl() {
    kickstartApp();
  }

  get vtkVolumes(){
    return this._vtkVolumes
  }
  set vtkVolumes(vtkVolume){
    this._vtkVolumes[this.seriesNumber]= vtkVolume
  }
}

export default MPR.getInstance();
